import { Injectable } from '@angular/core';
import { Cacheable } from 'ts-cacheable';
import { Observable } from 'rxjs';
import { AgronomyTranslation } from '../shared/models/app.models';
import { AuthHttpService } from './authentication/auth-http.service';

/* Use this constant to map language codes as found in selectedLanguage.code in the data service
to the matching index in a translation object from the Agronomy API. */
const LANGUAGE_CODE_TRANSLATION_INDEX_PAIRS = {
  'en-US': 'en_US',
  'af-ZA': 'af_za',
  'pt-BR': 'pt',
  'es-ES': 'es_ES'
};

export enum TranslationCategory {
  Pest = 'pest',
  Disease = 'disease'
}


@Injectable({
  providedIn: 'root'
})
export class AgronomyTranslationService {

  constructor(private _authHttp: AuthHttpService) { }

  @Cacheable()
  fetchPestAndDiseaseTranslations(): Observable<AgronomyTranslation[]> {
    return this._authHttp.get(`agronomy/translations`);
  }

  public translateTypeName(
    typeNameToTranslate: string,
    type_id: number,
    translations: AgronomyTranslation[],
    languageCode: string
  ): string {
    const translation = translations.find(_ => _.related_id === type_id);
    if (translation) {
      const translatedType = translation[this.getTranslationIndex(languageCode)];
      if (translatedType) {
        typeNameToTranslate = translatedType;
      } else if (translation['en_US']) {
        typeNameToTranslate = translation['en_US'];
      }
    }
    return typeNameToTranslate;
  }

  private getTranslationIndex(languageCode): string {
    return LANGUAGE_CODE_TRANSLATION_INDEX_PAIRS[languageCode];
  }

}
